import moment from "moment";
import { useDetailsPanelContext } from "PFApp/booking/components/details_panel";
import EngagementPill from "PFApp/components/pills/engagement_pill";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";

import css from "./bars.module.scss";
import BasicBar from "./basic_bar";

interface EngagementBarProps {
  left: number;
  width: number;
  start: string;
  end: string;
  original: ProjectItem;
  state: string;
}

export const EngagementBar = ({ left, width, start, end, original, state }: EngagementBarProps) => {
  const { detailsData, openDetailsPanel, closeDetailsPanel } = useDetailsPanelContext();

  const { utc, formatDate } = useDateFormatter();
  const handleClick = () => {
    if (detailsData?.id === original.activity.id) {
      closeDetailsPanel();
    } else {
      openDetailsPanel({ id: original.activity.id, type: "engagement" });
    }
  };

  // eslint-disable-next-line id-length
  const durationInDays = moment.duration(utc(end).diff(utc(start))).humanize({ d: 1000 });

  const tooltipContent = (
    <div className={css.tooltip}>
      <div className={css.title}>{durationInDays}</div>
      <div>{`${formatDate(start)} - ${formatDate(end)}`}</div>
      <div>{`Due date: ${formatDate(original.activity.post_until)}`}</div>
    </div>
  );

  return (
    <BasicBar left={left} width={width} onClick={handleClick} tooltipContent={tooltipContent}>
      <EngagementPill state={state} />
    </BasicBar>
  );
};
